import * as mutations from './mutation-types'

export default {
  saveData ({commit}, {informations}) {
    commit(mutations.SAVE_SESSION, informations)
  },
  updatePhone ({commit}, phone) {
    commit(mutations.UPDATE_PHONE, {phone})
  }
}
